import { find } from 'lodash'
import type { AccountInfo } from '@src/endpoints/services/base.service'

/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
export function getAccountId(arn: string) {
  let retVal = arn
  const start = arn.indexOf('::')

  if (start !== -1) {
    try {
      const end = arn.indexOf(':', start + 2)
      retVal = arn.substring(start + 2, end)
    } catch (err) {}
  }
  return retVal
}

export function getAccountNameById(
  id: string,
  accountInfo: AccountInfo[],
  showId?: boolean
) {
  const foundAccount = find(accountInfo, a => a.account_id === id)
  const { account_name } = foundAccount || {}
  if (foundAccount && showId && account_name !== id) {
    return `${account_name} (${id})`
  }
  return foundAccount ? account_name : id
}

export function getCloudTypeById(id: string, accountInfo: AccountInfo[]) {
  const foundAccount = find(accountInfo, a => a.account_id === id)
  return foundAccount ? foundAccount.cloud_type : ''
}

export const correctEmailFormat = (email: string) =>
  (email || '').trim().toLowerCase()
